export default {
  namespaced: true,
  state: {
    complete: false,
    enabled: false,
    active: false
  },
  mutations: {
    setComplete ( state, bool ) {
      state.complete = bool
    },
    setEnabled ( state, bool ) {
      state.enabled = bool
    },
    activate ( state ) {
      state.active = true
    },
    deactivate ( state ) {
      state.active = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/demos/demo2.js